import { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import styles from "@/components/backgroundTasks/copyTaskIdButton.module.css";

const COPIED_FEEDBACK_DURATION_MS = 2000;

interface Props {
  taskId: string;
}

export default function CopyTaskIdButton({ taskId }: Props) {
  const { t } = useTranslation();
  const [taskIdCopied, setTaskIdCopied] = useState(false);

  useEffect(() => {
    if (!taskIdCopied) return;
    const timer = setTimeout(
      () => setTaskIdCopied(false),
      COPIED_FEEDBACK_DURATION_MS
    );
    return () => clearTimeout(timer);
  }, [taskIdCopied]);

  const copyTaskId = () => {
    navigator.clipboard?.writeText(taskId).then(
      () => setTaskIdCopied(true),
      () => undefined 
    );
  };

  return (
    <Tooltip
      arrow
      placement="top"
      title={
        taskIdCopied ? (
          t("copied")
        ) : (
          <span className={styles.taskIdTooltip}>
            {t("copy_task_id")}
            <code>{taskId}</code>
          </span>
        )
      }
    >
      <GenericButton
        variant="icon"
        color="iconBase"
        aria-label={t("copy_task_id")}
        onClick={copyTaskId}
      >
        {taskIdCopied ? <CheckIcon /> : <ContentCopyIcon />}
      </GenericButton>
    </Tooltip>
  );
}
